import * as React from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function ScoresContent() {
  return (
    <Box sx={{ px: 2, py: 6, maxWidth: 1440, mx: 'auto' }}>
      <Grid container spacing={4}>
        {Array.from({ length: 2 }).map((_, index) => (
          <Grid item key={index} xs={12} sm={6} md={4}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#fff',
                borderRadius: 2,
                boxShadow: 1,
                overflow: 'hidden',
              }}
            >
              <Box
                sx={{
                  height: 160,
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden',
                  backgroundColor: '#f5f5f5',
                }}
              >
                <CardMedia
                  component="img"
                  image="https://images.ctfassets.net/zw84cuagwed8/1yKt46c0wtcrQubKJ5VjaL/b6410eedb76746afd6549b8936b486e5/Screenshot_2025-06-09_225713.png"
                  alt="Oceanside Muni"
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
              </Box>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h4" sx={{ fontSize: 48, mb: 1 }} noWrap>
                  76
                </Typography>
                <Typography variant="body2" color="text.secondary" noWrap>
                  Oceanside Muni
                </Typography>
                <Typography variant="body2" color="text.secondary" noWrap>
                  7 Holes Claimed
                </Typography>
                <Typography variant="body2" color="text.secondary" noWrap sx={{ mb: 2 }}>
                  6/2/2025 1:00pm
                </Typography>
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>Stats</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Label</TableCell>
                          <TableCell>Value</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell>Row 1</TableCell>
                          <TableCell>123</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Row 2</TableCell>
                          <TableCell>456</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </AccordionDetails>
                </Accordion>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
